/** @format */
import React from 'react';
import classNames from 'classnames';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';

const ContentControlHOC = (ComposedComponent, updateStateCb, setComponentRef, onUpdateState) => {
  class ControlHOCClass extends React.Component {
    state = {
      ...this.props,
    };

    componentDidMount() {
      this.componentMounted = true;
      if (updateStateCb) updateStateCb(this.updateState);
    }

    componentWillUnmount() {
      // we have no idea of a component's lifecycle from the outside so this is a simple workaround
      // to fix the setState({}) no-op warning
      this.componentMounted = false;
    }

    // setup reference callback so setState can be called from outside the HOC
    updateState = newState => {
      if (onUpdateState) {
        onUpdateState(newState);
      }

      if (!this.componentMounted) return;

      this.setState({ ...this.state, ...newState });
    };

    render() {
      const {
        isComponentVisible,
        fullWidth,
        componentRef,
        showLabels,
        complexShowLogic,
        numberOfColumns,
        rootNumberOfColumns,
        parentNumberOfColumns: ignoreParent,
        controlTypeName,
        isHiddenMount,
        ...otherProps
      } = this.state;

      const { parentNumberOfColumns } = this.props;

      if (!isComponentVisible && !isHiddenMount) return null;

      // when `showLabels` is enabled we do not want these components to render their own label
      const showLabelIgnoreList = ['Radio', 'CheckBox', 'WP'];
      const labelProp = showLabels && showLabelIgnoreList.includes(controlTypeName) ? { label: undefined } : {};
      let componentProps = { ...otherProps };

      // if (!['WP', 'ReadOnly'].includes(controlTypeName)) {
      //   delete componentProps.origControlTypeName;
      // }

      if (!['Caption', 'Header', 'CheckBox', 'Radio', 'WP', 'DropDown'].includes(controlTypeName)) {
        delete componentProps.increaseFontSize;
      }

      const component = <ComposedComponent {...componentProps} {...labelProp} />;

      // render column
      if (typeof parentNumberOfColumns === 'number') {
        return (
          <div
            ref={setComponentRef}
            key={otherProps.id}
            className="content-parser-col"
            style={{
              flexBasis: `${100 / parentNumberOfColumns}%`,
              marginBottom: '10px',
            }}>
            {component}
          </div>
        );
      }

      /*
       * the isHiddenMount use case is really for table columns
       */
      const rowClass = classNames({
        'content-parser-row': true,
        'content-parser-center': this.state.align === 'C' ? true : false,
        'content-parser-Right': this.state.align === 'R' ? true : false,
        'content-parser-Left': this.state.align === 'L' ? true : false,
        'row-mount-hidden': isHiddenMount,
        'row-show': isComponentVisible,
        [`col-num-${rootNumberOfColumns}`]: rootNumberOfColumns,
      });

      const useQuestionAnswerFormat = !fullWidth && showLabels ? true : false;
      let labelText;

      if (useQuestionAnswerFormat) {
        labelText = transformDisplayText(
          otherProps.label,
          DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName],
          otherProps.increaseFontSize,
        );
        if (otherProps.helpText && ['CheckBox', 'Radio'].includes(controlTypeName)) {
          labelText = <InfoTooltip toolTipText={otherProps.helpText} labelText={labelText} inlineLabel />;
        }
      }

      return (
        <div className={rowClass} ref={setComponentRef} key={otherProps.id}>
          {useQuestionAnswerFormat ? (
            <React.Fragment>
              <div className="content-parser-question">
                <label className="question-label" htmlFor={otherProps.id}>
                  {labelText}
                </label>
              </div>
              <div className="content-parser-answer">{component}</div>
            </React.Fragment>
          ) : (
            <div className="content-fullwidth">{component}</div>
          )}
        </div>
      );
    }
  }

  return ControlHOCClass;
};

export default ContentControlHOC;
